import ActiveWordContext from "../context/ActiveWordContext";
import { useContext } from "react";
import styles from './Word.module.scss';

function Word(props) {
  const { activeWordId, setActiveWordId } = useContext(ActiveWordContext);
  let color_text = (props.confidence * 255).toString();
  let className = styles.word;
  if(activeWordId === props.id) className += " " + styles.active;
  return (
    <span
      className={className}
      onClick={() => props.id === activeWordId ? setActiveWordId(null) : setActiveWordId(props.id)}
    >
      {props.word}
    </span>
  );
}

export default Word;
